import React, { ComponentType } from 'react';

import { Redirect } from 'react-router';
import { Node, NavigationElement } from '../../models';
import { NotifiedRoute as Route } from '../../components';

import { ModuleSelectorProps } from '../../types';

import { buildCurrentNavigationTree } from './build-current-navigation-tree';

export const buildModuleRoutes = (
    ModuleSelector: ComponentType<ModuleSelectorProps>,
    nodes: Node[],
    parentNavigationElement: NavigationElement,
): JSX.Element => {
    // On gère uniquement les redirections et les modules
    return (
        <React.Fragment>
            {nodes
                .filter(n => n.path && (n.isModuleEntry || n.isRedirect))
                .map(node => {
                    const currentNavigationTree: NavigationElement = buildCurrentNavigationTree(
                        node,
                        parentNavigationElement,
                    );

                    return (
                        <Route
                            key={node.path}
                            structureNode={node}
                            navigationTree={currentNavigationTree}
                            path={currentNavigationTree.path}
                            render={() => {
                                if (node.isRedirect) {
                                    return <Redirect to={currentNavigationTree.path} />;
                                }

                                return <ModuleSelector structureNode={node} navigationTree={currentNavigationTree} />;
                            }}
                        />
                    );
                })}
        </React.Fragment>
    );
};
